<template>
  <section id="techstack" class="techstack-page">
    <div class="container">
      <div class="page-header">
        <a href="/" class="back-link">
          <font-awesome-icon icon="chevron-left" /> Back to Home
        </a>
        <h1 class="page-title">Tech Stack</h1>
      </div>

      <div class="tech-categories">
        <div class="tech-category">
          <h2 class="category-title">Frontend</h2>
          <div class="tech-tags">
            <span class="tech-tag">JavaScript</span>
            <span class="tech-tag">TypeScript</span>
            <span class="tech-tag">Vue.js</span>
            <span class="tech-tag">Nuxt.js</span>
            <span class="tech-tag">Tailwind CSS</span>
            <span class="tech-tag">Ant Design</span>
            <span class="tech-tag">Shadcn/UI</span>
            <span class="tech-tag">Bootstrap</span>
            <span class="tech-tag">Material UI</span>
            <span class="tech-tag">Styled Components</span>
          </div>
        </div>

        <div class="tech-category">
          <h2 class="category-title">Backend</h2>
          <div class="tech-tags">
            <span class="tech-tag">Node.js</span>
            <span class="tech-tag">PHP</span>
            <span class="tech-tag">PostgreSQL</span>
            <span class="tech-tag">MySQL</span>
            <span class="tech-tag">OAuth</span>
            <span class="tech-tag">JWT</span>
            <span class="tech-tag">REST</span>
            <span class="tech-tag">Sequelize</span>
          </div>
        </div>

        <div class="tech-category">
          <h2 class="category-title">DevOps & Cloud</h2>
          <div class="tech-tags">
            <span class="tech-tag">GitHub Actions</span>
            <span class="tech-tag">GitLab CI</span>
            <span class="tech-tag">Travis CI</span>
            <span class="tech-tag">Clever Cloud</span>
            <span class="tech-tag">DigitalOcean</span>
            <span class="tech-tag">Datadog</span>
          </div>
        </div>

        <!-- <div class="tech-category">
          <h2 class="category-title">AI & Machine Learning</h2>
          <div class="tech-tags">
            <span class="tech-tag">OpenAI</span>
            <span class="tech-tag">Anthropic</span>
            <span class="tech-tag">Mistral</span>
            <span class="tech-tag">Gemini</span>
          </div>
        </div> -->

        <div class="tech-category">
          <h2 class="category-title">Tools & Others</h2>
          <div class="tech-tags">
            <span class="tech-tag">Git</span>
            <span class="tech-tag">GitHub</span>
            <span class="tech-tag">GitLab</span>
            <span class="tech-tag">VS Code</span>
            <span class="tech-tag">JetBrains IntelliJ</span>
            <span class="tech-tag">Figma</span>
            <span class="tech-tag">Slack</span>
            <span class="tech-tag">Linear</span>
            <span class="tech-tag">JIRA</span>
            <span class="tech-tag">Dbeaver</span>
            <span class="tech-tag">Console Cloud google</span>
            <span class="tech-tag">Search Console</span>
            <span class="tech-tag">Postman</span>
            <span class="tech-tag">Thunder Client</span>
            <span class="tech-tag">Vercel</span>
            <span class="tech-tag">Netlify</span>
            <span class="tech-tag">Dbeaver</span>
            <span class="tech-tag">Taiga.io</span>
            <span class="tech-tag">cPanel</span>
            <span class="tech-tag">npm</span>
            <span class="tech-tag">Figma</span>
            <!-- <span class="tech-tag">OpenAI/Codex</span>
            <span class="tech-tag">Anthropic</span>
            <span class="tech-tag">Mistral</span>
            <span class="tech-tag">Gemini</span>
            <span class="tech-tag">Perplexity</span> -->
            <span class="tech-tag">AI Agentic/Generative</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TechStackPage",
  mounted() {
    document.title = "Jayson Gomba - Tech Stack";
  },
  beforeUnmount() {
    document.title = "Jayson Gomba";
  },
};
</script>

<style scoped>
.techstack-page {
  min-height: 100vh;
  padding: 20px 320px;
  padding-bottom: 50px;
  background-color: var(--bg-primary);
}

.page-header {
  margin-bottom: 1rem;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

.back-link:hover {
  color: var(--primary-color);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.tech-categories {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.category-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1rem;
}

.tech-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.tech-tag {
  display: inline-block;
  padding: 0.3rem 1.25rem;
  background-color: transparent;
  border: 1.5px solid hsl(var(--foreground) / 0.28);
  border-radius: var(--border-radius);
  font-size: 0.875rem;
  color: hsl(var(--foreground));
  cursor: default;
}



@media (max-width: 768px) {
  .techstack-page {
    padding: 24px 16px;
  }

  .page-header {
    margin-bottom: 1.25rem;
  }

  .back-link {
    margin-bottom: 0.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .tech-categories {
    gap: 1.25rem;
  }

  .category-title {
    font-size: 1.25rem;
    margin-bottom: 0.5rem;
  }

  .tech-category {
    padding: 0;
  }

  .tech-tag {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
}
</style>
